import src from "IMAGE";
export default { src, width: 1080, height: 1079, blurWidth: 0, blurHeight: 0};
